import * as React from 'react';

export const zaFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_330)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_330'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_330)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#000C8A'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#E1392D'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M10.684 13.3333L2.66667 20.044H0V0H2.66667L10.6667 6.66667H28V13.3333H10.684Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M10.2667 12L0.666667 20L0 20.044V0H0.666667L10.2667 8H28V12H10.2667Z'
                    fill='#007847'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 4L8 10L0 16V4Z'
                    fill='#FFB915'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 5.33333L6.33333 9.99999L0 14.6667V5.33333Z'
                    fill='#151515'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_330'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
